import './App.css';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { ThemeProvider } from '@mui/material';
import theme from 'theme/theme';
import { AppRoutes } from 'components/AppRoutes';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from 'context/auth/AuthProvider';
import { NodeContextValuesExtractor } from "components/NodeContextValuesExtractor";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const lang = localStorage.getItem('i18nextLng') || 'pl';

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(
    resourcesToBackend((language, _, callback) => {
      import(`./locales/${language}.json`)
        .then((resources) => callback(null, resources))
        .catch((error) => callback(error, null));
    })
  )
  .init({
    fallbackLng: lang,
    debug: false,
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
  });


const queryClient = new QueryClient();

const App = () => {
  return (
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <SnackbarProvider maxSnack={3}>
            <AuthProvider>
              <NodeContextValuesExtractor>
                <AppRoutes />
              </NodeContextValuesExtractor>
            </AuthProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </QueryClientProvider>
  );
};

export default App;
